module.exports = __webpack_public_path__ + "static/media/ctoc.67bb3cfd.png";